import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">Evaluating progress</div>
                                            <p>You need to evaluate progress regularly. This might be
                                                observation or feedback from others.
                                                When you talk to the individual about your findings, make sure
                                                you give praise as well as indicating
                                                what needs attention, if necessary. </p>
                                            <div className="border_subtitle">New directions</div>
                                            <p>People and organisations change. Often, what was once useful
                                                becomes inappropriate or
                                                redundant. If it becomes apparent that amendments need to be
                                                made to an individual’s
                                                development programme, be flexible.</p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <p>Keep the development plan alive, and there’s more chance that
                                                    the individual will develop.</p>
                                            </div>
                                            <div className="border_subtitle">Taking stock</div>
                                            <p>It’s vital to take stock of both the individual’s achievements
                                                and your own performance in
                                                facilitating development. For the individual, this is about the
                                                extent to which objectives were
                                                met – taking into account any amendments or other things beyond
                                                their control, along the way!
                                                Where goals have been achieved, give praise and recognition. If
                                                not, a discussion should take
                                                place about what needs to change (in either the person or the
                                                plan). Encourage individuals to tell
                                                you whether the way you’ve handled things was helpful or
                                                otherwise.</p>
                                            <p>For you as a developer of people, it is important that you
                                                continuously learn from your experiences.
                                                Encourage the individuals that you are developing to give you
                                                feedback on the extent to which
                                                you have been helpful. What are the things you did well and what
                                                things could you have done
                                                better? Use this information to produce your own development
                                                objectives in relation to how you
                                                could become even better at developing others.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>SOURCES OF DATA
                                            </div>
                                            <p>Here’s our checklist of things to find out about an individual
                                                and their role, before embarking on
                                                a development plan:</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top" colSpan="2"
                                                        className="green_curve green_curve1">The Role
                                                        Requirements (Present and Future)
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">The job description.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">The ‘person specification’.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Their annual objectives.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">Their development plan.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Organisation’s competency
                                                        framework.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">Benchmarking data; that is,
                                                        information about what others in the same role are
                                                        currently doing.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Information about competitors;
                                                        that is, information about what competitors are
                                                        currently doing.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">Business plans and strategic
                                                        documents; that is, information about skills required to
                                                        meet future
                                                        business needs.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Information about advances in
                                                        areas of expertise.
                                                    </td>

                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}